import { useMutation, useQueryClient } from 'react-query'

import { useCurrentSite } from '../../components/SitesProvider'
import request from '../../config/axios'
import QueryKeys from './QueryKeys'

const useDeleteTreatment = () => {
  const queryClient = useQueryClient()
  const currentSiteId = useCurrentSite()?.id

  return useMutation((treatmentId: string) => {
    const url = `/impacts/patient_treatments/${treatmentId}?site_ids[]=${currentSiteId}`

    return request.delete(url).then((r) => {
      queryClient.invalidateQueries(QueryKeys.patientCases({}))
      return r.data
    })
  })
}

export default useDeleteTreatment
